import React from 'react';

import styles from './expertiseStyles';

const Expertise = ({ userProfile }) => {
  const { sectorExpertise, geographicExpertise, assetClassExpertise } = userProfile;
  const items = [
    { label: 'Sector', value: sectorExpertise.join(', ') },
    { label: 'Geographic', value: geographicExpertise.join(', ') },
    { label: 'Asset Class', value: assetClassExpertise.join(', ') }
  ].filter(item => item.value);
  return (
    <div>
      <ul className={styles.expertiseList}>
        {items.map((item, idx) => (
          <li key={idx}>
            <h4>{item.label}</h4>
            <span>{item.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Expertise;
